<!-- eslint-disable vue/no-v-html -->
 <!-- class special-text here to help UX identify text allowing html instead of having to ask dev -->
<template>
  <p v-if="tag === 'p'" class="special-text" :class="{ 'd-inline': inline }" v-html="html" />
  <div v-else class="special-text" :class="{ 'd-inline': inline }" v-html="html" />
</template>
<script lang="ts" setup>
import type {DirectiveBinding} from "vue";

withDefaults(defineProps<{
    html: string | undefined,
    inline?: boolean,
    // The element to render. A <div> cannot sit inside a <p>, so text that is a
    // paragraph renders as one (tag="p") instead of being wrapped in a <p> -- the
    // translation's HTML must then be inline-only.
    //
    // One v-if/v-else element per tag, NOT <component :is>: Vue's SSR compiler
    // drops v-html on a dynamic component, so every VHtml server-rendered empty
    // and only filled in after hydration (a flash of missing text, and a
    // hydration mismatch, on every page). v-html-vhtml.ssr.spec.ts pins that.
    // Adding a tag means adding a branch. The v-if/v-else pair is still one root,
    // and the eslint disable stays above <template>: a comment inside it becomes
    // a second root node in dev/test and breaks callers that read this
    // component's $el (CmsContent).
    tag?: 'div' | 'p',
}>(), {
  inline: false,
  tag: 'div'
})
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- documents createContextualFragment alternative for script-executing HTML; kept for future use
const vSwap = {
  bind (el: HTMLInputElement, binding: DirectiveBinding<string>) {
    // createContextualFragment allows script execution
    // why you would probably want to sanitize the html
    // e.g. using https://github.com/cure53/DOMPurify
    // const safe = DOMPurify.sanitize(binding.value)
    const frag = document.createRange()
      .createContextualFragment(binding.value)
    el.replaceWith(frag)
  }
}

</script>
